import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Type definitions for our tables
export interface Exploration {
  id: string
  user_id: string
  data: {
    query: string
    snapshot: {
      llmResponse: {
        overview: string
        concepts: any[]
      }
      searchResults: any[]
      intent: any
      theme?: any
    }
  }
  created_at: string
}

export interface UserData {
  user_id: string
  memory: Record<string, any>
  preferences: Record<string, any>
  updated_at: string
}